<template>
    <div class="nav-content-wrapper" v-if="!$store.state.waitingRequest">
        <admin-navbar />
        
        <div class="content">
            <h2>Accueil</h2>

            <h3>Salut {{ infosUser.identifiant }} !</h3>
            <p>Dernière connexion: {{ dateFr(new Date(infosUser.derniere_connexion)) }}</p>

            <div class="cards">
                <div class="card-container">
                    <div class="card first">
                        <div class="top">
                            <i class="fas fa-user-circle"></i>
                            <h3>Visiteurs</h3>
                        </div>
                        <div class="content">
                            <p>• {{ appViews }} sont passés sur le site</p>
                            <p>• {{ totalCommentCount }} commentaires postés</p>
                        </div>
                    </div>
                </div>
                <div class="card-container">
                    <div class="card second">
                        <div class="top">
                            <i class="fas fa-gamepad"></i>
                            <h3>Jeux</h3>
                        </div>
                        <div class="content">
                            <p>• {{ todayGamesCount }} ajoutés aujourd'hui</p>
                            <p>• {{ totalGamesCount }} ajoutés au total</p>
                            <p>• {{ totalCommentedGames }} jeux commentés</p>
                        </div>
                    </div>
                </div>
                <div class="card-container">
                    <div class="card third">
                        <div class="top">
                            <i class="fas fa-eye"></i>
                            <h3>Vues</h3>
                        </div>
                        <div class="content">
                            <p>{{ totalViewCount }} vues au total</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
    import Session from '../mixins/adminSession';
    import AdminNavbar from '../views/AdminNavbar';

    export default {
        name: "AdminPanel",
        mixins: [Session],
        components: {
            'admin-navbar': AdminNavbar
        },
        data() {
            return {
                formData: null,
                interval: null,
                appViews: 0,
                todayGamesCount: 0,
                totalGamesCount: 0,
                totalViewCount: 0,
                totalCommentCount: 0,
                totalCommentedGames: 0
            }
        },
        mounted() {
            this.formData = new FormData();
            this.formData.append('data', JSON.stringify({post: "1"}));

            this.getData();
            this.interval = setInterval(() => { this.getData() }, 5000);
        },
        methods: {
            getData() {
                this.getVisitors();
                this.getTodayGamesCount();
                this.getTotalGamesCount();
                this.getTotalViewCount();
                this.getTotalCommentCount();
            },
            getVisitors() {
                axios.post(this.$store.state.apiUrl+"?request=getVisitors", this.formData).then((response) => {
                    if(response.data) {
                        this.appViews = response.data;
                    }
                });
            },
            getTodayGamesCount() {                
                axios.post(this.$store.state.apiUrl+"?request=getTodayGamesCount", this.formData).then((response) => {
                    if(response.data) {
                        this.todayGamesCount = response.data;
                    }
                });
            },
            getTotalGamesCount() {                
                axios.post(this.$store.state.apiUrl+"?request=getTotalGamesCount", this.formData).then((response) => {
                    if(response.data) {
                        this.totalGamesCount = response.data;
                    }
                });
            },
            getTotalViewCount() {                
                axios.post(this.$store.state.apiUrl+"?request=getTotalViewCount", this.formData).then((response) => {
                    if(response.data) {
                        this.totalViewCount = response.data;
                    }
                });
            },
            getTotalCommentCount() {
                axios.post(this.$store.state.apiUrl+"?request=getTotalCommentCount", this.formData).then((response) => {
                    if(response.data.commentsNb) {
                        this.totalCommentCount = response.data.commentsNb;
                        this.totalCommentedGames = response.data.gamesNb;
                    }
                });
            },
            dateFr(date) {
                function handleZeros(nbr, type = '') {
                    nbr = (type == 'mm') ? nbr++ : nbr;
                    let string = (nbr < 10) ? ('0' + nbr.toString()) : (nbr.toString());
                    return string;
                }

                let dd = handleZeros(date.getDate());
                let mm = handleZeros(date.getMonth()+1, 'mm');
                let yyyy = handleZeros(date.getFullYear());

                let hh = handleZeros(date.getHours());
                let ii = handleZeros(date.getMinutes());

                return dd + '/' + mm + '/' + yyyy + ' à ' + hh + ':' + ii;
            }
        }
    }
</script>

<style scoped src="@/assets/admin.css">
</style>
